import React, { Component } from 'react';
import styled from 'styled-components';
import { PrestoAppTheme } from 'presto-mini-apps-lib';


class HorizontalScroller extends Component {
    componentDidMount() {
        const { onRef } = this.props;
        if(!!onRef) onRef(this);

        this.containerRef = React.createRef();
    }

    componentWillUnmount() {
        const { onRef } = this.props;
        if(!!onRef) onRef(null);
    }

    scrollLeftTo = (posX) => {
        const scroller = this.containerRef.current.getElementsByClassName('scroller')[0];
        scroller.scrollTo(posX, 0);
    }
    
    getContainerWidth = () => {
        return this.containerRef.current.getBoundingClientRect().width;
    };
    
    getCurrentScrollX = () => {
        const scroller = this.containerRef.current.getElementsByClassName('scroller')[0];
        return scroller.scrollLeft;
    };

    render() {
        const { scrollHandler } = this.props;

        return (
            <HorizontalScrollerWrapper
                innerRef={this.containerRef}
                // ref={this.containerRef}
                className="scroller-component"
                sidePadded={!!this.props.sidePadded}
                height={this.props.height}
                onScroll={scrollHandler || null}
            >
                <div className="scroller">
                    {this.props.children}
                </div>
            </HorizontalScrollerWrapper>
        );
    }
}


export default HorizontalScroller;

const HorizontalScrollerWrapper = styled.div`
    height: ${props => props.height || '240'}px;
    // padding-bottom: ${PrestoAppTheme.layout.smallGap};
    // overflow: hidden;
    @media only screen and (max-width: 768px) {
        height: ${props => props.height ? (props.height - 10) : '240'}px;
    }
        
    & .scroller {
        height: calc(100% + ${PrestoAppTheme.layout.commonGap});
        padding: ${props => props.sidePadded 
                    ? `0 ${PrestoAppTheme.layout.smallGap}` 
                    : `0 0 ${PrestoAppTheme.layout.smallGap} 0`
        };
        // NOTE: padding shorthand '0 0 X X' is intentional to counter the following issue in FF 
        // https://bugzilla.mozilla.org/show_bug.cgi?id=748518
        white-space: nowrap;
        overflow-x: auto; 
        overflow-y: hidden; 
        
        & > ul {
            ${PrestoAppTheme.layout.blankListStyle}
            
            & > li {
                display: inline-block;
                white-space: normal;
                vertical-align: top;
            }
        }
    }   
        
    /* 
    @media (min-width: ${PrestoAppTheme.layout.appWidthBreakpointCommon}) {
        padding-bottom: ${PrestoAppTheme.layout.commonGap};
    
        & .scroller {
            padding: 0 0 ${PrestoAppTheme.layout.smallGap} 0;
        }
    } 
    */
`;
